import { Col, ColType, Crud, CrudAction, CrudApi } from "../../comp/crud";
import {
    ApiClient,
    displayMortgageLoanStatus,
    displayMortgageLoanType,
    getLoanTypeItemOpt,
    getMortgageLoanStatusOpt, Lead,
    displayRepaymentPlanStatus,
} from "../../api/ApiClient";
import React, { useEffect, useMemo, useState } from "react";
import { ArrayField, Button, Form, Modal, TabPane, Tabs, Tag, Toast, Typography, Row, Col as RowCol, Table,Descriptions, Popover, Tooltip } from '@douyinfe/semi-ui';
import RepaymentPlan from "./repaymentPlan";
import {
    IconMinusCircle,
    IconModalStroked,
    IconMoneyExchangeStroked,
    IconPlusCircle,
    IconUser,
    IconBarChartHStroked,
    IconIdCard,
    IconCoinMoneyStroked,
    IconHelpCircle,
} from "@douyinfe/semi-icons";
import { formatAmountZhCn, formatDate, renderStatDetailContent, renderLoanStatusTag } from "../../utils";
import { FormApi } from "@douyinfe/semi-ui/lib/es/form";

let apiClient = ApiClient.getDefault();
const { Text } = Typography;

export interface MortgageLoanProps {
    leadId?: number;
    leadName?: string;
    openMode?: string;
}

export default function IndexMortgageLoan(props: MortgageLoanProps) {
    const [statData, setStatData] = useState([] as any[]);
    const [statDataObj, setStatDataObj] = useState({} as any);
    const [planShow, setPlanShow] = useState(false);
    const [loanId, setLoanId] = useState(undefined as undefined | number);
    const [loanIds, setLoanIds] = useState(undefined as undefined | number[]);
    const [leadId, setLeadId] = useState(undefined as undefined | number);
    const [platform, setPlatform] = useState(undefined as undefined | string);
    const [paidType, setPaidType] = useState("all");
    const [loan, setLoan] = useState({} as any);
    const [crudApi, setCrudApi] = useState(undefined as undefined | CrudApi);
    const [makePlanModal, setMakePlanModal] = useState(false);
    const [makePlanFormApi, setMakePlanFormApi] = useState(
        undefined as undefined | FormApi
    );
    const [makePlanSaving, setMakePlanSaving] = useState(false);
    const role = localStorage.getItem("role");
    const [showMortgageField, setShowMortgageField] = useState(true);
    const [showCardField, setShowCardField] = useState(false);
    const [showBorrowField, setShowBorrowField] = useState(false);
    const [teamMembersTree, setTeamMembersTree] = useState([] as any[]);
    const [showSaveLoanModal, setShowSaveLoanModal] = useState(false);
    const [saveLoanFormApi, setSaveLoanFormApi] = useState(
        undefined as undefined | FormApi
    );
    const [selectedLeads, setSelectedLeads] = useState([] as any[]);
    const [saveLoanSaving, setSaveLoanSaving] = useState(false);
    const [mortgageLoan, setMortgageLoan] = useState(undefined as undefined | any);
    const [selectedPlanList, setSelectedPlanList] = useState([] as any);

    let cols: Col[] = [
        {
            name: "ID",
            key: "id",
            hideInEdit: true,
            hideInCreate: true,
            hideInList: true,
            type: ColType.NUMBER
        },
        
        {
            name: "客户ID",
            key: "leadId",
            width: 80,
            showInFilter: false,
            type: ColType.NUMBER,
            hideInEdit: true,
            hideInList: false,
        },
        {
            name: "客户姓名",
            key: "leadName",
            width: 80,
            type: ColType.STRING,
            hideInEdit: true,
            hideInCreate: true,
            showInFilter: false,
            hideInList: false,

        },
        {
            name: "贷款类型",
            key: "loanType",
            width: 100,
            type: ColType.SELECT,
            showInFilter: true,
            getOptions: () => Promise.resolve(getLoanTypeItemOpt()),
            render: (value, record, index) => {
               
                    return displayMortgageLoanType(value);
                
            },
        },
        {
            name: "贷款平台",
            key: "platform",
            width: 150,
            type: ColType.STRING,
            showInFilter: true,
        },
        {
            name: "城市",
            key: "leadCity",
            width: 40,
            type: ColType.SELECT,
            getOptions: () => apiClient.getDictAsOpts("city"),
            hideInEdit: true,
            hideInCreate: true,
            showInFilter: true,

        },

        {
            name: "按揭专员ID",
            key: "agentId",
            type: ColType.STRING,
            showInFilter: false,
            hideInList: true,
            hideInCreate: true,
            hideInEdit: true,
        },
        {
            name: "按揭专员",
            key: "agentName",
            width: 80,
            type: ColType.STRING,
            showInFilter: true,
            hideInCreate: true,
            hideInEdit: true,
        },
        {
            name: "销售ID",
            key: "saleId",
            type: ColType.STRING,
            showInFilter: false,
            hideInList: true,
            hideInCreate: true,
            hideInEdit: true,
        },
        {
            name: "销售",
            key: "saleName",
            width: 80,
            type: ColType.STRING,
            showInFilter: false,
            hideInCreate: true,
            hideInEdit: true,
           
        },
        

        {
            name: "贷款金额",
            key: "amount",
            width: 70,
            type: ColType.NUMBER,
            render: (value, record, index) => {
                
                    return <Typography.Text>{formatAmountZhCn(value)}</Typography.Text>;
                
            },
        },
        {
            name: "期数",
            key: "term",
            width: 50,
            type: ColType.STRING,
            showInFilter:true,
        },

        {
            name: "月供金额",
            key: "oneTermAmount",
            width: 70,
            type: ColType.NUMBER,
            optional: true,
            render: (value, record, index) => {
                
                    return <Typography.Text>{formatAmountZhCn(value)}</Typography.Text>;
                
            },

        },
        {
            name: "还款日期",
            key: "firstPayDate",
            width: 90,
            type: ColType.DATE_RANGE,
            showInFilter:true,
        },

        {
            name: "还款计划",
            key: "totalTerm",
            width: 40,
            type: ColType.NUMBER,
            showInFilter: false,
            hideInCreate: true,
            hideInEdit: true,
            render: (value, record, index) => {
                
                    return (
                        <Typography.Text
                            link
                            onClick={() => {
                                openRepaymentPlanModal(
                                    record.id,
                                    record.leadId,
                                    undefined,
                                    "all"
                                );
                            }}
                        >
                            {value}
                        </Typography.Text>
                    );
                

            },
        },
        {
            name: "还款笔数",
            key: "paidTerm",
            width: 40,
            type: ColType.NUMBER,
            showInFilter: false,
            hideInCreate: true,
            hideInEdit: true,
            render: (value, record, index) => {
               
                    return (
                        <Typography.Text
                            link
                            onClick={() => {
                                openRepaymentPlanModal(
                                    record.id,
                                    record.leadId,
                                    undefined,
                                    "YJQ"
                                );
                            }}
                        >
                            {value}
                        </Typography.Text>
                    );
                
            },
        },
        {
            name: "实还金额",
            key: "paidAmount",
            width: 70,
            type: ColType.NUMBER,
            hideInEdit: true,
            hideInCreate: true,
            render: (value, record, index) => {
                
                    return <Typography.Text>{formatAmountZhCn(value)}</Typography.Text>;
                
            },
        },
        
        {
            name: "借款日期",
            key: "borrowDate",
            width: 90,
            type: ColType.DATE_RANGE,
            hideInList: false,
            showInFilter: true,
            optional: true,
        },
        {
            name: "借款人",
            key: "borrowerName",
            width: 90,
            type: ColType.STRING,
            hideInList: false,
            showInFilter: true,
            optional: true,
        },
        {
            name: "状态",
            key: "status",
            width: 60,
            render:(value, record, index) => renderLoanStatusTag(value, record),
            type: ColType.SELECT,
            showInFilter: true,
            hideInEdit: true,
            hideInCreate: true,
            getOptions: (row) => Promise.resolve(getMortgageLoanStatusOpt())
        },
        {
            name: "账单日",
            key: "billDay",
            width: 50,
            type: ColType.NUMBER,
            optional: true,
            render: (value, record, index) => {
               
                return <Typography.Text>{value}</Typography.Text>;
            },
        },
        {
            name: "结清日期",
            key: "settleDate",
            type: ColType.DATE,
            hideInEdit: true,
            hideInCreate: true,
            hideInList: false,
            width: 90,
        },
        {
            name: "创建时间",
            key: "createdAt",
            width: 100,
            type: ColType.DATETIME,
            hideInEdit: true,
            hideInCreate: true,
            hideInList: true,
        },
        {
            name: "贷款编号",
            key: "loanNo",
            type: ColType.STRING,
            showInFilter: true,
            hideInList: false,
            hideInCreate: true,
            hideInEdit: true,
            width: 110,
        },
    ]



    useEffect(() => {

        //获取所有销售和按揭专员
        apiClient
            .getTeamMemberByDataScopeAsOpts("payment")
            .then((opts) => setTeamMembersTree(opts));
        return () => {
            console.log("离开页面------------");

        };
    }, []);

     useEffect(() => {
            //刷新统计
            initStatCountData();
        }, [statDataObj]);

        const queryStatCount = async (data: any) => {
            let params = {
                ...data,
            };
            console.log("统计报表查询参数：", params);
            apiClient.request("/mortgageLoan/listSum", "GET", data).then((resp) => {
                setStatDataObj(resp.data);
            });
        };

        const initStatCountData = async () => {
            console.log("统计报表返回数据：", statDataObj);
            if (!statDataObj) {
                return;
            }

            const data = [
                { key: "", value: "汇总" },
                {
                    key: "贷款数",
                    value: statDataObj.loanCount,
                },
                {
                    key: "贷款金额",
                    value: formatAmountZhCn(statDataObj.totalAmount),
                },
               
                {
                    key: "信用卡代过账",
                    value: formatAmountZhCn(statDataObj.totalHelpPostingAmount),
                },
                {
                    key: (
                        <Tooltip style={{ maxWidth: 400 }}
                            content={"出款金额 = 贷款代还 + 信用卡代还  + 个人借款"}>
                            出款金额
                            <IconHelpCircle style={{ color: "#E91E63" }} />
                        </Tooltip>
                    ),
                    value: formatAmountZhCn(statDataObj.totalHelpPaidAmount + statDataObj.totalCardHelpPaidAmount + statDataObj.totalBorrowAmount),
                },
                {
                    key: "个人借款金额",
                    value: formatAmountZhCn(statDataObj.totalBorrowAmount),
                },
                {
                    key: "个人借款已还金额",
                    value: formatAmountZhCn(statDataObj.totalReturnAmount),
                },
                 {
                    key: (
                        <Tooltip style={{ maxWidth: 400 }}
                            content={"支出合计 = 贷款代还 + 信用卡代还  + 个人借款 - 个人借款已还"}>
                            支出合计
                            <IconHelpCircle style={{ color: "#E91E63" }} />
                        </Tooltip>
                    ),
                    value: <span style={{ color: "#E91E63" }}>{formatAmountZhCn(statDataObj.totalHelpPaidAmount + statDataObj.totalCardHelpPaidAmount -statDataObj.totalReturnAmount)}</span>,
                },
            ];
            setStatData(data);
        };

    

        const listSumStat = () => {
            const style = {
                boxShadow: "var(--semi-shadow-elevated)",
                backgroundColor: "var(--semi-color-bg-2)",
                borderRadius: "4px",
                padding: "5px",
                margin: "auto",
            };
            return (
                <div style={{ display: "flex", width: "100%", margin: "5px", alignItems: "center" }}>
                    <Popover
                        content={renderStatDetailContent(statDataObj)}
                        trigger="hover"
                        position="bottomLeft"
                        showArrow
                    >
                        <a style={{ marginRight: 12, whiteSpace: 'nowrap', color: 'var(--semi-color-link)', cursor: 'pointer' }}><IconBarChartHStroked style={{ marginRight: 4 }} />统计详情</a>
                    </Popover>
                    <Descriptions data={statData} row align={"center"} style={style} />
                </div>
            );
        };
    

    const handleSaveLoanButtonClick = async (row: any) => {

        if (row.loanType === 'MORTGAGE') {
            setShowMortgageField(true);
            setShowCardField(false);
            setShowBorrowField(false);
        } else if (row.loanType === 'CARD') {
            setShowCardField(true);
            setShowMortgageField(false);
            setShowBorrowField(false);
        } else {
            setShowBorrowField(true);
            setShowMortgageField(false);
            setShowCardField(false);
        }
        apiClient.getLead(row.leadId).then((resp) => {
            row.leadName = resp.name;
            row.applyAmount = resp.applyAmount;
            setMortgageLoan(row);
            setShowSaveLoanModal(true);

        });

    };

    const editAction: CrudAction = {
        name: "编辑",
        action: handleSaveLoanButtonClick,
    };

    const handleSaveLoanClick = async (optType: string) => {
        try {
            if (saveLoanFormApi!.getValue("loanType") == "CARD") {
                saveLoanFormApi!.setValue("oneTermAmount", 0);
            }
            await saveLoanFormApi!.validate();
            let values = saveLoanFormApi!.getValues();
            values["id"] = mortgageLoan?.id;//更新必须要传ID
            let leadId = values["leadId"];
            if (values["amount"] <= 0) {
                Toast.info("贷款（借款）金额必须大于0");
                return;
            }
            //校验oneTermAmount字段"贷款类型为信贷客户必须填写月供金额，信用卡客户不用填"
            if (values["loanType"] == "MORTGAGE" && (!values["oneTermAmount"] || values["oneTermAmount"] <= 0)) {
                Toast.info("请填写月供金额且月供金额大于0");
                return;
            }
            if (values["loanType"] == "BORROW" && !values["borrowDate"]) {
                Toast.info("请填写借款日期");
                return;
            }

            values["lastQueryTime"] = formatDate(values["lastQueryTime"]);
            values["firstPayDate"] = formatDate(values["firstPayDate"]);
            values["borrowDate"] = formatDate(values["borrowDate"]);
            Modal.confirm({
                title: "是否确认修改贷款信息。",
                content: "",
                onOk: async () => {
                    try {
                        setSaveLoanSaving(true);
                        await apiClient.request(
                            "/mortgageLoan",
                            "PUT",
                            undefined,
                            values
                        );
                        Toast.info("保存贷款信息成功");
                        if (optType == "update") {
                            setSelectedLeads([]);
                            crudApi?.refresh();
                            setSaveLoanSaving(false);
                            setShowSaveLoanModal(false);
                        } else {
                            saveLoanFormApi?.reset();
                            saveLoanFormApi?.setValue("leadId", leadId);
                        }


                    } catch (e) {
                        setSaveLoanSaving(false);
                    }
                },
            });


        } catch (e) {
            setSaveLoanSaving(false);
        }
    };


    const deleteMortgageLoan = (row: any) => {
        Modal.confirm({
            title: "是否确认删除？该操作会删除客户所有的还款计划。",
            content: "",
            onOk: async () => {
                try {
                    await apiClient.deleteMortgageLoan(row.id);
                    Toast.info("删除成功");

                    crudApi?.refresh();
                } catch (e) {
                }
            },
        });
    }

    const deleteAction: CrudAction = {
        name: "删除",
        action: deleteMortgageLoan,
    };

    const makeRepaymentPlan = async (
        loan: any,
    ) => {
        setLoan(loan);
        //调用接口查询还款计划
        apiClient.request(
            "/repaymentPlan",
            "GET",
            { page: 1, size: 100, loanId: loan.id, statusOrderBy: 0 }
        ).then((resp: any) => {
            setSelectedPlanList(resp.data.records);
            setMakePlanModal(true);
        });

    };

    const handleMakeRepaymentPlan = async () => {
        await makePlanFormApi!.validate();
        let values = makePlanFormApi!.getValues();
        console.log(values);
        //如果为空，则不处理
        if (!values.rules || values.rules.length == 0) {
            Toast.info("请填写还款计划！");
            return;
        }
        Modal.confirm({
            title: "是否确认新增还款计划。",
            content: "",
            onOk: async () => {
                try {

                    let dateStrArr: any = [];
                    values.rules.forEach((item: any) => {
                        dateStrArr.push(formatDate(item));
                    });
                    //去除重复的日期
                    dateStrArr = [...new Set(dateStrArr)];
                    console.log(dateStrArr);

                    let params = {
                        id: values.id,
                        planDates: dateStrArr,
                    };

                    try {
                        setMakePlanSaving(true);
                        await apiClient.request(
                            "/mortgageLoan/manualMakeRepaymentPlan",
                            "POST",
                            undefined,
                            params
                        );
                        Toast.info("新增还款计划成功");
                        setLoan({});
                        crudApi?.refresh();
                        setMakePlanSaving(false);
                        setMakePlanModal(false);

                        crudApi?.refresh();
                    } catch (e) {
                        setMakePlanSaving(false);
                    }

                } catch (e) {
                }
            },
        });
    }

    const makePlanAction: CrudAction = {
        name: "新增还款计划",
        action: makeRepaymentPlan,
    };


    const openRepaymentPlanModal = async (
        id: number | undefined, leadId: number | undefined, platform: string | undefined, paidType: string
    ) => {
        //打印日志
        console.log("打印日志：", id, leadId, platform, paidType);
        setLoanId(id);
        setLeadId(leadId);
        setPlatform(platform);
        setPaidType(paidType)
        if (!id && !platform) {
            let loans: any = crudApi?.getData().filter(item => item.id != 999999);
            let ids: any = [];
            loans.forEach((item: any) => {
                item.children.map((itemN: any) => ids.push(itemN.id));
            })
            setLoanIds(ids)
        }
        setPlanShow(true);
    };


    // 处理表单提交
    const handleFormSubmit = async (type: any, field: any) => {
        let newPlans: any[] = [];
        console.log("type field:", type, field);

        if ("add" == type || "blurAdd" == type) {
            let dueDate = makePlanFormApi!.getValue(field);
            console.log("payDay:", loan.payDay);
            dueDate = formatDate(dueDate);
            console.log("dueDate:", dueDate);
            if ("add" == type) {
                //最后两位替换为payDay
                dueDate = dueDate.substring(0, dueDate.length - 2) + loan.payDay;
            }

            //判断还款日期dueDate是否存在selectedPlanList中
            if (selectedPlanList) {
                let newPlans: any = [...selectedPlanList];
                let valid = 0;
                newPlans.forEach((item: any) => {
                    if (item.dueDate === dueDate && !item.field) {
                        valid = 1;
                    }
                    else if (item.dueDate != dueDate && item.field && item.field === field) {
                        valid = 2;//更新
                        item.dueDate = dueDate;
                    } else if (item.dueDate === dueDate && item.field && item.field === field) {
                        valid = 3;//没变化
                    } else if (item.dueDate === dueDate && item.field && item.field != field) {
                        valid = 4;//重复
                    }

                })
                console.log("valid:", valid);
                if (valid == 1 || valid == 4) {
                    Toast.warning("该还款日期已存在");
                    return;
                }
                if (valid == 2) {
                    setSelectedPlanList(newPlans);
                    Toast.success("已更新还款日期");
                    return;
                }
                if (valid == 3) {
                    return;
                }
            }

            //取selectedLoanList集合里对象的Id最大的
            let maxId = 0;
            let maxPeriodNo = 1;
            if (selectedPlanList && selectedPlanList.length > 0) {
                maxId = findMaxId(selectedPlanList);
                maxPeriodNo = findMaxPeriodNo(selectedPlanList);
            }
            let id = maxId + 1;
            let periodNo = maxPeriodNo + 1;
            const addData = {
                ...loan,
                id: id,
                paidAmount:0,
                periodNo: periodNo,
                dueDate: dueDate,
                status: "HKZ",
                field: field,
            };
            newPlans = [...selectedPlanList, addData];
            setSelectedPlanList(newPlans);
            console.log("newPlans", newPlans);
        } else if ("remove" == type || "clean" == type) {

            //移除不存在的

            const filteredPlans = selectedPlanList.filter((plan: any) =>
                plan.field != field
            );
            console.log("移除后的数据：", filteredPlans);
            setSelectedPlanList(filteredPlans);

        }
    };

    function findMaxId(items: any[]): any {
        if (items.length === 0) return null;

        return items.reduce(
            (maxId, item) => Math.max(maxId, item.id),
            items[0].id // 初始值设为第一个元素的ID
        );
    }

    function findMaxPeriodNo(items: any[]): any {
        if (items.length === 0) return null;

        return items.reduce(
            (max, item) => Math.max(max, item.periodNo),
            items[0].periodNo // 初始值设为第一个元素的ID
        );
    }

    // 计算汇总数据
    const summary = useMemo(() => {
        if (selectedPlanList && selectedPlanList.length > 0) {
            return {
                amount: selectedPlanList[0].amount,
                oneTermAmount: safeSumBy(selectedPlanList, 'oneTermAmount'),
                paidAmount: safeSumBy(selectedPlanList, 'paidAmount'),
            };

        } else {
            return {
                amount: 0,
                oneTermAmount: 0,
                paidAmount: 0,
            };
        }

    }, [selectedPlanList]);

    /**
     * 计算属性安全总和
     * @param items 对象数组
     * @param prop 数字类型的属性名
     * @returns 有效数字的总和
     */
    function safeSumBy<T>(items: T[], prop: keyof T): number {
        return items.reduce((sum, item) => {
            const value = item[prop];

            // 类型安全验证
            if (typeof value === 'number' && !isNaN(value)) {
                return sum + value;
            }

            // 尝试转换为数字
            const numericValue = Number(value);
            return !isNaN(numericValue) ? sum + numericValue : sum;
        }, 0);
    }
    // 合并数据和汇总行
    const dataWithSummary = [{
        key: 'summary',
        periodNo: '汇总',
        id: 999999,
        leadId: 999999,
        amount: summary.amount,
        oneTermAmount: summary.oneTermAmount,
        paidAmount: summary.paidAmount,
    }, ...selectedPlanList];

    //日期增加一个月
    const addMonth = (date: Date) => {
        date.setMonth(date.getMonth() + 1);
        return formatDate(date);
    }


    return <>
        <Modal
            icon={<IconModalStroked size={"extra-large"} style={{ color: 'blue' }} />}
            style={{ width: 600, height: 660 }}
            title="编辑贷款"
            visible={showSaveLoanModal}
            confirmLoading={saveLoanSaving}
            onCancel={() => setShowSaveLoanModal(false)}
            footer={
                <div>
                    <Button type="tertiary" onClick={() => setShowSaveLoanModal(false)}>
                        取消
                    </Button>
                    <Button type="primary" onClick={() => handleSaveLoanClick("update")}>
                        保存
                    </Button>
                </div>
            }
        >
            <Form getFormApi={(formApi) => setSaveLoanFormApi(formApi)}
                labelPosition="left"
                labelWidth={130}
                labelAlign="right">
                <Form.InputNumber
                    rules={[{ required: true, message: "请填写" }]}
                    key="leadId"
                    label="客戶ID"
                    initValue={mortgageLoan?.leadId}
                    field="leadId"
                    readonly
                    width={300}
                />
                <div style={{ display: 'flex' }}>

                    <Form.Input
                        key="leadName"
                        label={"客户姓名"}
                        initValue={mortgageLoan?.leadName}
                        field="leadName"
                        readonly
                        style={{ width: 100, marginLeft: 10 }}
                    />
                    <Form.Input
                        key="applyAmount"
                        style={{ width: 100, marginLeft: 10 }}
                        label={"签约金额"}
                        initValue={mortgageLoan?.applyAmount}
                        field="applyAmount"
                        readonly
                    />
                </div>
                <Form.Select
                    rules={[{ required: true, message: "请填写" }]}
                    key="loanType"
                    label="贷款类型"
                    disabled
                    style={{ width: 200 }}
                    field="loanType"
                    initValue={mortgageLoan?.loanType}
                    optionList={getLoanTypeItemOpt().map((o) => {
                        return {
                            label: o.label,
                            value: o.value,
                            disabled: o.disabled,
                        };
                    })}
                    onChange={value => {
                        if (value === 'MORTGAGE') {
                            setShowMortgageField(true);
                            setShowCardField(false);
                            setShowBorrowField(false);
                        } else if (value === 'CARD') {
                            setShowCardField(true);
                            setShowMortgageField(false);
                            setShowBorrowField(false);
                        } else {
                            setShowBorrowField(true);
                            setShowMortgageField(false);
                            setShowCardField(false);
                        }
                    }
                    }
                />

                {/* 如果是“贷款” */}
                {showMortgageField && (
                    <div>
                        <Form.Input
                            rules={[{ required: true, message: "请填写" }]}
                            key="platform"
                            label="貸款平台"
                            style={{ width: 200 }}
                            field="platform"
                            initValue={mortgageLoan?.platform}
                        ></Form.Input>

                        <Form.InputNumber
                            rules={[{ required: true, message: "请填写" }]}
                            key="amount"
                            label="貸款金額"
                            field="amount"
                            initValue={mortgageLoan?.amount}
                        />
                        <Form.InputNumber
                            rules={[{ required: true, message: "请填写" }]}
                            key="term"
                            label="按揭期数"
                            field="oneTermAmount"
                            initValue={mortgageLoan?.term}
                            disabled
                        />
                        <Form.InputNumber
                            rules={[{ required: true, message: "请填写" }]}
                            key="oneTermAmount"
                            label="月供金额"
                            field="oneTermAmount"
                            initValue={mortgageLoan?.oneTermAmount}
                        />
                        <Form.DatePicker
                            rules={[{ required: true, message: "请选择日期" }]}
                            key="firstPayDate"
                            type="date"
                            label="首次还款日"
                            field="firstPayDate"
                            initValue={mortgageLoan?.firstPayDate}
                        />
                    </div>
                )}

                {/* 如果是“信用卡” */}
                {showCardField && (
                    <div>
                        <Form.Input
                            rules={[{ required: true, message: "请填写" }]}
                            key="platform"
                            label="貸款平台"
                            style={{ width: 200 }}
                            field="platform"
                            initValue={mortgageLoan?.platform}
                        ></Form.Input>

                        <Form.InputNumber
                            rules={[{ required: true, message: "请填写" }]}
                            key="amount"
                            label="貸款金額"
                            field="amount"
                            initValue={mortgageLoan?.amount}
                        />

                        <Form.DatePicker
                            rules={[{ required: true, message: "请选择日期" }]}
                            key="firstPayDate"
                            type="date"
                            label="首次还款日"
                            field="firstPayDate"
                            initValue={mortgageLoan?.firstPayDate}
                        />
                        <Form.InputNumber
                            key="billDay"
                            label="账单日"
                            field="billDay"
                            initValue={mortgageLoan?.billDay}
                        />
                    </div>
                )}

                {/* 如果是“个人借款” */}
                {showBorrowField && (
                    <div>
                        <Form.Select
                            placeholder="请选择出款人"
                            rules={[{ required: true, message: "请选择出款人" }]}
                            label={"出款人"}
                            field="borrowerId"
                            optionList={teamMembersTree}
                            showClear={true}
                            filter={true}
                            style={{ width: 300 }}
                            initValue={mortgageLoan?.borrowerId}
                        ></Form.Select>

                        <Form.InputNumber
                            rules={[{ required: true, message: "请填写" }]}
                            key="amount"
                            label="出借金額"
                            field="amount"
                            initValue={mortgageLoan?.amount}
                        />
                        <Form.DatePicker
                            rules={[{ required: true, message: "请选择日期" }]}
                            key="borrowDate"
                            type="date"
                            label="借款日期"
                            field="borrowDate"
                            initValue={mortgageLoan?.borrowDate}

                        />
                        <Form.DatePicker
                            rules={[{ required: true, message: "请选择日期" }]}
                            key="firstPayDate"
                            type="date"
                            label="约定还款日"
                            field="firstPayDate"
                            initValue={mortgageLoan?.firstPayDate}
                        />

                    </div>
                )}

                <Form.DatePicker
                    key="lastQueryTime"
                    type="date"
                    label="最后查询日期"
                    field="lastQueryTime"
                />


            </Form>
        </Modal>

        <Modal
            icon={<IconModalStroked size={"extra-large"} style={{ color: 'blue' }} />}
            style={{ width: 1200, height: 750 }}
            title="生成还款计划"
            visible={makePlanModal}
            okText="批量生成"
            confirmLoading={makePlanSaving}
            onOk={handleMakeRepaymentPlan}
            onCancel={() => setMakePlanModal(false)}
        >
            <Form getFormApi={(formApi) => setMakePlanFormApi(formApi)}
                labelPosition="left"
                labelWidth={130}
                labelAlign="right">
                <Row>

                    <RowCol span={6}>
                        <div style={{ display: 'none' }}>
                            <Form.Input
                                rules={[{ required: true, message: "请填写" }]}
                                key="id"
                                noLabel={true}
                                initValue={loan?.id}
                                disabled={true}
                                field="id"
                            />
                        </div>
                        <Form.Input
                            rules={[{ required: true, message: "请填写" }]}
                            key="platform"
                            label="贷款平台"
                            initValue={loan?.platform}
                            disabled={true}
                            field="platform"
                            width={100}
                        />
                        <Form.Section text={'还款日期'}>
                            <ArrayField field='rules'>
                                {({ add, arrayFields, addWithInitValue }) => (
                                    <React.Fragment>
                                        <Button icon={<IconPlusCircle />} onClick={() => {
                                            //找到selectedPlanList中最大的还款日期
                                            if (selectedPlanList.length > 0) {
                                                const maxRepaymentDate = selectedPlanList.reduce((prev: any, curr: any) => {
                                                    return prev.dueDate > curr.dueDate ? prev : curr;
                                                }).dueDate;
                                                //日期增加一个月
                                                addWithInitValue(addMonth(new Date(maxRepaymentDate)));

                                                let field = "rules[" + String(arrayFields.length) + "]";
                                                console.log(field);
                                                handleFormSubmit("add", field)


                                            } else {
                                                add();
                                            }

                                        }} style={{ marginLeft: 8 }}>新增</Button>
                                        {
                                            arrayFields.map(({ field, key, remove }, i) => (
                                                <div key={key} style={{ width: 400, display: 'flex' }}>
                                                    <Form.DatePicker
                                                        rules={[{ required: true, message: "请选择还款日期" }]}
                                                        type="date"
                                                        noLabel={true}
                                                        field={`${field}`}

                                                        onBlur={() => handleFormSubmit("blurAdd", `${field}`)}
                                                        style={{ width: 200 }}
                                                    />
                                                    <Button
                                                        type='danger'
                                                        theme='borderless'
                                                        icon={<IconMinusCircle />}
                                                        onClick={(value) => {
                                                            if(arrayFields.length-1 != i){
                                                                Toast.info("不能从中间删除日期，请按顺序操作，先删除后面的日期");
                                                                return;
                                                            }
                                                           
                                                            remove();
                                                            handleFormSubmit("remove", `${field}`);
                                                        }
                                                        }
                                                        style={{ margin: 12 }}
                                                    />
                                                </div>
                                            ))
                                        }
                                    </React.Fragment>
                                )}
                            </ArrayField>
                        </Form.Section>
                    </RowCol>
                    <RowCol span={18}>
                        <Form.Section text={'还款计划'}>
                            <Table
                                rowKey="id"
                                onRow={(record: any, index) => {
                                    return {
                                        style: {
                                            backgroundColor: record.field ? 'rgba(var(--semi-green-2), 1)' : 'transparent',
                                        },

                                    };
                                }}
                                columns={[
                                    {
                                        title: "期数", dataIndex: "periodNo", render: (text: any, record: any) => (
                                            record.key === 'summary'
                                                ? <Typography.Title heading={5}>{text}</Typography.Title>
                                                : text + "期"
                                        )
                                    },

                                    {
                                        title: "贷款金额", dataIndex: "amount", render: (text: number, record: any) => (
                                            record.key === 'summary'
                                                ? <Typography.Title heading={5}>{formatAmountZhCn(text)}</Typography.Title>
                                                : formatAmountZhCn(text)
                                        )
                                    },
                                    {
                                        title: "应还金额", dataIndex: "oneTermAmount", render: (text: number, record: any) => (
                                            record.key === 'summary'
                                                ? <Typography.Title heading={5}>{formatAmountZhCn(text)}</Typography.Title>
                                                : formatAmountZhCn(text)
                                        )
                                    },
                                    { title: "计息日期", dataIndex: "borrowPlanStartDate" },
                                    { title: "应还日期", dataIndex: "dueDate" },
                                    { title: "实际出款人", dataIndex: "paidUserName" },
                                    {
                                        title: "实际还款金额", dataIndex: "paidAmount", render: (text: number, record: any) => (
                                            record.key === 'summary'
                                                ? <Typography.Title heading={5}>{formatAmountZhCn(text)}</Typography.Title>
                                                : formatAmountZhCn(text)
                                        )
                                    },
                                    { title: "实际还款日期", dataIndex: "paidDate" },
                                    {
                                        title: "状态", dataIndex: "status", render: (value, record: any, index) => {
                                            if (record.key === 'summary') {
                                                return "";

                                            }
                                            if (value == "YQ") {
                                                return (
                                                    <Tag color="red" key={value} size='large'
                                                        shape='circle'
                                                        type='solid'> {displayRepaymentPlanStatus(value)} </Tag>
                                                );
                                            }
                                            else if (value == "YJQ") {
                                                return (<Tag color="green" key={value} size='large'
                                                    shape='circle'
                                                    type='solid'> {displayRepaymentPlanStatus(value)} </Tag>);
                                            }
                                            else {
                                                return (<Tag color="blue" key={value} size='large'
                                                    shape='circle'
                                                    type='solid'> {displayRepaymentPlanStatus(value)} </Tag>);
                                            }
                                        },
                                    },

                                ]}
                                pagination={{ pageSize: 15 }}
                                dataSource={dataWithSummary}
                                bordered
                            />
                        </Form.Section>
                    </RowCol>
                </Row>
            </Form>
        </Modal>
        <Modal icon={<IconModalStroked size={"extra-large"} style={{ color: 'blue' }} />} title={"还款计划"}
           fullScreen={true}
            headerStyle={{
                flexShrink: 0, // 关键属性 2：固定标题
                borderBottom: '1px solid var(--semi-color-border)'
            }}
            bodyStyle={{
                overflow: 'auto', // 关键属性 3：启用内容滚动
                padding: '16px 24px',
                flex: 1
            }}
            footer={null}
            hasCancel={false} onCancel={() => setPlanShow(false)} onOk={() => setPlanShow(false)} visible={planShow}>
            <div><RepaymentPlan loanId={loanId} loanIds={loanIds} leadId={leadId} platform={platform} paidType={paidType} /></div>
        </Modal>

<Row>
            <RowCol span={24}>{listSumStat()}</RowCol>
        </Row>
        <Crud
            getCrudApi={(crudApi) => {
                setCrudApi(crudApi);
            }}
            canUpdate={false}
            canCreate={false}
            canDelete={false}
            name="贷款查询"
            entityKey="mortgageLoan"
            fetchDataAfterMethod={queryStatCount}
            pageSize={50}
            rowActionWidth={40}
            cols={cols}
        />

    </>
}